import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { getFirebaseWebConfig, isFirebaseConfigured } from './config';

let app: FirebaseApp | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (!isFirebaseConfigured()) {
    throw new Error(
      'Firebase is not configured. Set REACT_APP_FIREBASE_* environment variables.',
    );
  }
  if (!app) {
    const config = getFirebaseWebConfig()!;
    app = getApps().length > 0 ? getApps()[0]! : initializeApp(config);
  }
  return app;
}
